import { render, staticRenderFns } from "./RFileUpload.vue?vue&type=template&id=353c167f&scoped=true&"
import script from "./RFileUpload.vue?vue&type=script&lang=js&"
export * from "./RFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./RFileUpload.vue?vue&type=style&index=0&id=353c167f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c167f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
